export default __webpack_public_path__ + "static/media/list_main_16_1.cc62d1c1.png";